module.exports = __webpack_public_path__ + "img/LogoNorterraBlanco.9409533f.svg";